import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { Guest } from "../../common/models/guest";
import { Team } from "../../common/models/team";
import { GuestTeam } from "../../common/models/guest-team";
import { AthleteGuest } from "../../common/models/athlete-guest";
import { TeamsProvider } from "../../teams/providers/teams-provider";
import { GuestItemRightsList, GuestRights, mapUserRightsToGuestRights } from "./guests-rights";
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { LangsProvider } from "../../common/providers/langs-provider";
import { CurrentUser } from "../../common/providers/current-user";
import { User } from "../../common/models/user";
import { map, switchMap } from "rxjs/operators";
import { OrganizationMembership } from "../../common/models/organization-membership";
import { OrganizationMembership_OrganizationRole } from "../../common/models/organization-membership_organization-role";
import { Athlete } from "../../common/models/athlete";
import { AthleteCoach } from "../../common/models/athlete-coach";
import { Coach } from "../../common/models/coach";
import { OrganizationRole } from "../../common/models/organization-role";
import { CoachRow } from "../../coaches/providers/coaches-provider";
import { Paginator } from "../../common/models/paginator";

@Injectable({
  providedIn: 'root'
})
export class GuestsProvider {
  public Ready: Promise<boolean> = new Promise((resolve, reject) => resolve(false));
  public guestRights: GuestRights = new GuestRights(this._utils);

  private availableGuests: Guest[] = [];
  private availableTeams: Team[] = [];
  private availableGuestTeamRelations: GuestTeam[] = [];
  private availableAthleteGuestRelations: AthleteGuest[] = [];

  constructor(
    private _conf: ConfigProvider,
    private _utils: UtilsProvider,
    private _api: ApiBaseService,
    private _langs: LangsProvider,
    private _currentUser: CurrentUser,
    private _teamsProvider: TeamsProvider,
    private _currentUserRoles: CurrentUserRolesProvider,
    private api: ApiBaseService,
  ) {
    this.Ready = new Promise((resolve, reject) => {

      Promise.all([

        // this.getGuests(),
        // this.getGuestTeamRelations(),
        // this.getAthleteGuestRelations(),
        // this._teamsProvider.getTeams(),

      ])
        .then((data: any[]) => {

          this.availableGuests = data[0];
          this.availableGuestTeamRelations = data[1];
          this.availableAthleteGuestRelations = data[2];
          this.availableTeams = data[3];

          resolve(true);
        })
        .catch(reject);
    });
  }
  public get(organizationId:number, userId: number): Observable<User> {
    return this.api.call('get', `organizations/${organizationId}/guests/${userId}`, {}, this._currentUser.getAccessToken())
      .pipe(
        map((data: any) => User.fromAPI(data))
      );
  }

  public getGuests(organizationId: number): Observable<User[]> {
    return this.api.call('get', `organizations/${organizationId}/guests`, {}, this._currentUser.getAccessToken())
      .pipe(
        map((result: any) => User.fromAPIList(result.data))
      );
  }

  public createGuestRow(organizationId: number, user: User): GuestRow {
    return this._guestRowFromUser(user, organizationId);
  }

  private _guestRowFromUser(user: User, organizationId: number): GuestRow {
    return {
      user: User.fromAPI(user),
      guest: Guest.fromAPI(user.guest ?? {}),
      athletes: User.fromAPIList(
        user.guest?.athletes
          ?.map((athlete: Athlete) => athlete.user)
          ?.filter((user): user is User => user !== undefined) ?? []
      ),
      athleteNames: user.guest?.athletes?.map((athlete: Athlete) => athlete.user?.firstName + ' ' + athlete.user?.lastName) ?? [],
      teams: Team.fromAPIList(user.guest?.teams ?? []),
      teamNames: user.guest?.teams?.map((team: Team) => team.name) ?? [],
      rights: mapUserRightsToGuestRights(user.rights ?? []),
    };
  }

  public getGuestRow(organizationId: number, userId: number): Observable<GuestRow> {
    return this.api.call('get',`organizations/${organizationId}/guests/${userId}`, {}, this._currentUser.getAccessToken())
      .pipe(
        map((user: User) => {
          return this._guestRowFromUser(user, organizationId)
        }),
      );
  }

  public getGuestsPaginator({organizationId, pageNumber, orderBy, userName}: {organizationId: number, pageNumber?: number, orderBy?: string, userName?: string}): Observable<Paginator> {
    return this.api.call('get',`organizations/${organizationId}/guests/`, {
      page: pageNumber,
      order: orderBy,
      userName: userName,
    }, this._currentUser.getAccessToken())
      .pipe(
        map((result: Paginator) => result),
      );
  }

  public patchGuest(organizationId: number, userId: number, data:Object): Observable<any> {
    return this.api.call('patch',
      `organizations/${organizationId}/guests/${userId}`,
      data
    );
  }

  public deleteGuest(organizationId: number, userId: number): Observable<void> {
    return this.api.call('delete',`organizations/${organizationId}/guests/${userId}`, {}, this._currentUser.getAccessToken());
  }



  /*** END NEW REQUESTS ***/
  /*** ****************************** ***/
  /*** ******************************************** ***/
  /*** ****************************** ***/
  /*** OLD REQUESTS ***/



  public getAvailableGuestUsers(organizationId: number): Observable<User[]> {
    return this.api.call('get',`organizations/${organizationId}/guests/users`).pipe(
      map((data: any) => {
        return User.fromAPIList(data);
      })
    );
    // return this._storage.select(User)
    //     .where('id').equals(OrganizationMembership, 'userId')
    //     .and('organizationId', OrganizationMembership).equals(organizationId)
    //     .and('id', OrganizationMembership).equals(OrganizationMembership_OrganizationRole, 'organizationMembershipId')
    //     .and('organizationRoleId', OrganizationMembership_OrganizationRole).in([OrganizationRole.ID_GUEST])
    //     .get();
  }

  public saveGuestAthletes(organizationId: number, guestRow: GuestRow): Observable<GuestRow> {
    return this.api.call('post','organizations/' + organizationId + '/guests/' + (guestRow.user.id ?? 0) + '/athletes',
      guestRow,
      this._currentUser.getAccessToken()
    ).pipe(
      switchMap((data: any) => {
        return this.getGuestRow(organizationId, data.guest.userId);
      })
    );
  }

  public saveGuestTeams(organizationId: number, removeRelations: boolean, guestRow: GuestRow): Observable<GuestRow> {
    return this.api.call('post', 'organizations/' + organizationId + '/guests/' + (guestRow.user.id ?? 0) + '/teams',
      {
        atr: guestRow,
        rer: removeRelations
      },
      this._currentUser.getAccessToken()
    ).pipe(
      switchMap((data: any) => {
        return this.getGuestRow(organizationId, data.guest.userId);
      })
    );
  }

  /**
   * Find a Coach for a given user in an Organization
   * @param user
   * @param organization
   */
  // public getCoachByUserAndOrganization(user: User, organization: Organization): Promise<Guest> {
  //     return this._storage.select(Guest)
  //         .where('userId').equals(OrganizationMembership, 'userId')
  //         .and('organizationId', OrganizationMembership).equals(organization.id)
  //         .and('id', OrganizationMembership).equals(OrganizationMembership_OrganizationRole, 'organizationMembershipId')
  //         .and('organizationRoleId', OrganizationMembership_OrganizationRole).in([OrganizationRole.ID_GUEST])
  //         .and('userId', Guest).equals(user.id)
  //         .get(1);
  // }

  public saveGuest(organizationId: number, guest: Guest, user: User): Observable<Guest> {
    return this.api.call(                'post',
      'organizations/' + organizationId + '/guests/' + (user.id ? user.id : 0),
      {
        guest: guest.toJson(),
        user: user.toJson(),
      },
      this._currentUser.getAccessToken(),
      false
    ).pipe(
      map((data: any) => {
        guest = Guest.fromAPI(data.guest);
        user = User.fromAPI(data.user);
        const membership = OrganizationMembership.fromAPI(data.organizationMembership);
        const roles: OrganizationMembership_OrganizationRole[] = OrganizationMembership_OrganizationRole.fromAPIList(data.organizationMembership_organizationRoles);
        return guest;
      })
    );
  }

}

export interface GuestRow {
  user: User;
  guest: Guest;
  athletes: Athlete[];
  athleteNames: string[];
  teams: Team[];
  teamNames: string[];
  rights?: GuestItemRightsList;
}
